import { Tree } from 'primereact/tree';
import { useEffect, useState } from 'react';
import Api from '@/api/api.ts';
import { useNavigate, useParams } from 'react-router';
import { TreeNode } from 'primereact/treenode';
import './meeting_materials.scss';

function MeetingMaterials() {
  const { meetingUid } = useParams();
  const [meetingName, setMeetingName] = useState('');
  const [nodes, setNodes] = useState<TreeNode[]>([]);
  const navigate = useNavigate();

  const getMeeting = async (meetingUid: string) => {
    try {
      const title = (await Api.getMeeting(meetingUid)).title;
      setMeetingName(title);
    } catch (error) {
      console.error('Error getting meeting:', error);
      navigate('/');
    }
  };

  const normalizeTree = (nodes: TreeNode[]): TreeNode[] =>
    nodes.map((node) => {
      if (node.children && node.children.length === 0) {
        if (node.data == 'Documents' || node.data == 'Boards') {
          return {
            ...node,
            label: node.label + ' (отсутствуют)',
            children: []
          };
        }
        return {
          ...node,
          children: [
            {
              key: node.key + '-empty',
              label: 'Нет данных',
              icon: 'pi pi-ban',
              leaf: true
            }
          ]
        };
      }
      if (node.children) {
        return { ...node };
      }
      return node;
    });

  const getFiles = async (meetingUid: string) => {
    let files: string[] = [];
    let boards: string[] = [];
    try {
      files = await Api.getAllFiles(meetingUid);
    } catch (error) {
      console.error('Error getting materials:', error);
      return;
    }
    try {
      boards = await Api.getTeacherBoards(meetingUid);
    } catch (error) {
      console.error('Error getting teacher boards:', error);
      return;
    }

    const treeMaterials = files.map((file) => ({
      key: file,
      label: file.split('/').pop(),
      data: `//${window.location.hostname}/${file}`,
      icon: 'pi pi-file-pdf'
    }));
    const treeBoards = boards.map((board) => ({
      key: board,
      label: board.split('/').pop(),
      data: `//${window.location.hostname}/${board}`,
      icon: 'pi pi-image'
    }));

    setNodes(
      normalizeTree([
        {
          key: '0',
          label: 'Материалы',
          data: 'Documents',
          icon: 'pi pi-copy',
          children: treeMaterials
        },
        {
          key: '1',
          label: 'Доски',
          data: 'Boards',
          icon: 'pi pi-images',
          children: treeBoards
        }
      ])
    );
  };

  useEffect(() => {
    if (meetingUid) {
      void getMeeting(meetingUid);
      void getFiles(meetingUid);
    }
  }, [meetingUid]);

  const nodeTemplate = (node: TreeNode) => {
    if (node.data && node.data.endsWith('.pdf') | node.data.endsWith('.png')) {
      return (
        <a href={node.data} target="_blank" rel="noopener noreferrer">
          {node.label}
        </a>
      );
    }
    return <span>{node.label}</span>;
  };

  return (
    <div className="meeting-info">
      <div className="meeting-info__materials">
        <h2 className="meeting-info__meeting-name">{meetingName}</h2>
        <div className="meeting-info__card-of-materials">
          <p className="meeting-info__materials-title">
            <span>Материалы с занятия</span>
          </p>
          <Tree
            value={nodes}
            nodeTemplate={nodeTemplate}
            className="meeting-info__list-of-materials"
          />
        </div>
      </div>
    </div>
  );
}

export default MeetingMaterials;
